'use client';

import { type ReactNode } from 'react';
import { type LogParameters, useLoggerRootContext } from '@skin-seoul/utils';
import { useEffect, useRef, useState } from 'react';
import { useKlaviyo } from '@/hooks';
interface Props {
  eventName: string;
  params?: LogParameters;
  children: ReactNode;
}
const KlaviyoLoggingView = ({
  eventName,
  params,
  children
}: Props) => {
  const {
    track
  } = useKlaviyo();
  const {
    appName,
    metadata,
    isInitialized
  } = useLoggerRootContext();
  const [hasLogged, setHasLogged] = useState(false);
  const prevParamsRef = useRef<LogParameters | undefined>(params);
  useEffect(() => {
    if (isInitialized === false) {
      return;
    }
    if (!hasLogged) {
      track(eventName, {
        app_name: appName,
        ...metadata,
        ...params
      });
      setHasLogged(true);
      prevParamsRef.current = params;
      return;
    }
    const paramsChanged = prevParamsRef.current !== params;
    if (paramsChanged) {
      track(eventName, {
        app_name: appName,
        ...metadata,
        ...params
      });
      prevParamsRef.current = params;
    }
  }, [isInitialized, hasLogged, appName, metadata, params, track, eventName]);
  return <>{children}</>;
};
export default KlaviyoLoggingView;